import { User } from "firebase/auth";
import { IJob } from "@/hooks/useJobs";

export const isSharedJobView = (
  job: IJob | null | undefined,
  authUser: User | null | undefined,
): boolean => !!job && !!authUser && job.userId !== authUser.uid;
